import { render, staticRenderFns } from "./RegionBranchesList.vue?vue&type=template&id=29997c72&scoped=true&"
import script from "./RegionBranchesList.vue?vue&type=script&lang=js&"
export * from "./RegionBranchesList.vue?vue&type=script&lang=js&"
import style0 from "./RegionBranchesList.vue?vue&type=style&index=0&id=29997c72&lang=scss&scoped=true&"
import style1 from "./RegionBranchesList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29997c72",
  null
  
)

export default component.exports